module.exports = __webpack_public_path__ + "static/media/facebook.56f2c5f8.svg";